import React from "react";
import "./App.scss";
import ContactSalesComponent from "./components/ContactSales/ContactSalesComponent.js";
import HeroComponent from "./components/Hero/HeroComponent.js";
import LearnComponent from "./components/Learn/LearnComponent.js";
import Header from "./components/Navbar/Header.js";
import PricingComponent from "./components/Pricing/PricingComponent.js";
import UseCases from "./components/UseCases/UseCases.js";
import Footer from "./components/ContactSales/Footer.js";
import "./components/Footer.scss";
const App = () => {
  return (
    <div className="App">
      <Header />
      <HeroComponent />
      <UseCases />
      <LearnComponent />
      <PricingComponent />
      <ContactSalesComponent />
    </div>
  );
};

export default App;
